<style lang="less" scoped>
    .consumption-record-container {
        width: 100%;
        height: 100%;
        background-color: #ffffff;
        display: flex;
        flex-direction: column;
        .header-div {
            width: 100%;
            height: 183px;
            background: linear-gradient(143deg, #00B5B7 0%, #73D899 100%);
            .header-title-div {
                margin: 12px 20px;
                display: flex;
                .header-left-img-div {
                    height: 32px;
                    width: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .header-title {
                    height: 32px;
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 32px;
                    margin-left: 10px;
                }
            }
            .account-degree-info-div {
                display: flex;
                margin-top: 32px;
                .left-account-info-div {
                    flex: 1;
                    margin-left: 20px;
                    .account-line {
                        height: 32px;
                        font-size: 16px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #FFFFFF;
                        line-height: 32px;
                    }
                    .dealer-line {
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                    }
                }
                .right-degree-div {
                    margin-right: 20px;
                    .degree-value-line {
                        height: 32px;
                        font-size: 24px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #FFFFFF;
                        line-height: 32px;
                    }
                    .degree-unit {
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                    }
                    .degree-title-line {
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                        text-align: right;
                    }
                }
            }
        }
        .record-list-div {
            flex: 1;
            background: #FFFFFF;
            border-radius: 30px;
            margin-top: -32px;
            display: flex;
            flex-direction: column;
            .record-top-line-div {
                width: 73px;
                height: 5px;
                background: #D1D1D1;
                border-radius: 4px;
                opacity: 0.39;
                margin: 10px auto;
            }
            .record-list-title-div {
                height: 22px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #000000;
                line-height: 22px;
                margin-left: 20px;
                margin-bottom: 10px;
            }
            .record-list-scroll-div{
                flex: 1;
                overflow-y: auto;
            }
            .record-list-child-div {
                margin: 12px 20px 0 20px;
                background: #F4F4FB;
                border-radius: 13px;
                .record-show-line-div {
                    display: flex;
                    .left-station-div {
                        flex: 1;
                        height: 40px;
                        line-height: 40px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis; 
                        font-size: 12px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #000000;
                        margin-left: 20px;
                    }
                    .time-info-div {
                        height: 40px;
                        line-height: 40px;
                        font-size: 12px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #000000;
                    }
                    .right-icon-div {
                        margin-left: 10px;
                        height: 40px;
                        width: 20px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-right: 12px;
                    }
                }
                .record-hide-info-div {
                    margin: 0px 20px;
                    padding-bottom: 16px;
                    .record-info-line-div {
                        display: flex;
                        font-size: 10px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #000000;
                    }
                }
            }
        }
        .record-list-scroll-div::-webkit-scrollbar {
            display: none;
        }
        .no-records-img-div{
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            .no-record-tips-div{
                margin-top: 32px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #000000;
            }
        }
    }
</style>

<template>
    <div class="consumption-record-container" >
        <div class="header-div">
            <div class="header-title-div">
                <div class="header-left-img-div" @click="backToMain">
                    <img src="../../assets/h5-img/direction-left.png" width="18" height="18">
                </div>
                <div class="header-title">消费记录</div>
            </div>
            <div class="account-degree-info-div">
                <div class="left-account-info-div">
                    <div class="account-line">账户：{{curSelCardInfo.useredBy}}</div>
                    <div class="dealer-line">运营商：{{curSelCardInfo.dealerName}}</div>
                </div>
                <div class="right-degree-div">
                    <div class="degree-value-line">{{curSelCardInfo.cardElectricBalance}}<span class="degree-unit"> 度</span></div>
                    <div class="degree-title-line">剩余度数</div>
                </div>
            </div>
        </div>
        <div class="record-list-div">
            <div class="record-top-line-div"></div>
            <div class="record-list-title-div">消费明细</div>
            <div class="record-list-scroll-div" v-if="consumptionList.length>0">
                <div class="record-list-child-div" v-for="(detail,index) in consumptionList" v-bind:key="detail.id">
                    <div class="record-show-line-div" @click="updateShowDetail(detail,index)">
                        <div class="left-station-div">{{detail.stationName}}</div>
                        <div class="time-info-div">{{detail.beginTime}}</div>
                        <div class="right-icon-div">
                            <img src="../../assets/h5-img/arrow-down-bold.png" width="11" height="7">
                        </div>
                    </div>
                    <div class="record-hide-info-div" v-if="detail.showHide">
                        <div class="record-info-line-div">
                            <div class="flex-1 flex">
                                <div class="line-child-title">充电度数：</div>
                                <div class="line-child-value">{{detail.chargeVal|| ' - '}}度</div>
                            </div>
                            <div class="flex-1 flex">
                                <div class="line-child-title">剩余度数：</div>
                                <div class="line-child-value">{{detail.chargeCardElecBalance || ' - '}}度</div>
                            </div>
                        </div>
                        <div class="record-info-line-div">
                            <div class="flex-1 flex">
                                <div class="line-child-title">电桩编号：</div>
                                <div class="line-child-value">{{detail.pileCode|| ' - '}}</div>
                            </div>
                            <div class="flex-1 flex">
                                <div class="line-child-title">充电时长：</div>
                                <div class="line-child-value">{{detail.chargeHourMinute|| ' - '}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="no-records-img-div" v-else>
                <img src="../../assets/h5-img/no-consumption.png" width="113" height="68">
                <div class="no-record-tips-div">没有找到消费记录</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                curSelCardInfo:{},
                consumptionList: [ ],
            }
        },
        methods: {
            init() {
                // 获取用户电卡储值列表
                this.getUserConsumption();
            },
            getUserConsumption(){
                let _ = this;
                _.$U.showLoading(_);
                const querInfo = {
                    corpNo:_.$C.corpNo,
                    userPhone:_.curSelCardInfo.useredBy,
                    chargeCardNo:_.curSelCardInfo.cardNo,
                    pageNum:0,
                    pageSize:999,
                };
                _.$H.post(_, _.$A.h5.consumption, querInfo).then(res => {
                    _.consumptionList = res.data.data;
                    _.$U.hideLoading(_);
                })
            },
            updateShowDetail(detail, index) {
                detail.showHide = !detail.showHide;
                this.$set(this.consumptionList[index], detail);
                this.$forceUpdate();
            },
            // 返回列表页
            backToMain(){
                this.$router.push({
                    name: 'h5_chargeCardDetail'
                })
            },
        },
        mounted() {
            this.curSelCardInfo = this.$store.state.curSelChargeCardInfo;
            this.init();
        }
    }
</script>